import { i18n } from "@/i18n";

export const translateFromLaravel = (errors) => {
  const formattedErrors = {};

  const map = {
    "validation.max.string": "validation.max",
    "validation.max.array": "validation.max_array",
    "validation.max.numeric": "validation.max_value",
    "validation.min.string": "validation.min",
    "validation.min.numeric": "validation.min_value",
    "validation.mimes": "validation.ext"
  };

  for (const fieldName in errors) {
    if (!Object.hasOwnProperty.call(errors, fieldName)) {
      continue;
    }

    formattedErrors[fieldName] = [];
    for (const errorKey of errors[fieldName]) {
      if (Object.hasOwnProperty.call(map, errorKey)) {
        // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
        formattedErrors[fieldName].push(i18n.global.t(map[errorKey]));
      } else {
        // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys
        formattedErrors[fieldName].push(i18n.global.t(errorKey));
      }
    }
  }

  return formattedErrors;
};
